import type { SplitExperimentsProps, SplitProps } from './types';
import { createContext, useContext, useMemo, useReducer } from 'react';
import { initState, reducers } from './reducers';
import { getSplitState } from './utils';

const SplitContext = createContext<{
  split: SplitProps;
  dispatch: ({ type, payload }: { type: string; payload: unknown }) => void;
}>({
  split: getSplitState(),
  dispatch: () => {},
});

export type SplitProviderProps = {
  children?: React.ReactNode;
  experiments?: SplitExperimentsProps;
  featureNames?: Array<string>;
};

export const SplitProvider = (props: SplitProviderProps) => {
  const [split, dispatch] = useReducer(
    reducers,
    initState({ experiments: props.experiments, featureNames: props.featureNames }),
  );

  const splitContext = useMemo(() => ({ split, dispatch }), [split, dispatch]);

  if (typeof window !== 'undefined') {
    // @ts-expect-error
    window.splitContext = splitContext;
  }
  return <SplitContext.Provider value={splitContext} {...props} />;
};

export const useSplitContext = () => {
  return useContext(SplitContext);
};
